import { Box } from "@mui/material";
import { Route, Routes } from "react-router-dom";
import VehicleSearch from "../component/Vehicle/VehicleSearch";

const VehiclePage = (props: any) => {
  return (
    <Box>
      <Routes>
        <Route path="/" element={<VehicleSearch />} />
      </Routes>
    </Box>
  );
};

export default VehiclePage;
